// removed by extract-text-webpack-plugin
module.exports = {"setting-wrapper":"setting-wrapper__setting-wrapper__g26e7","setting-header":"setting-wrapper__setting-header__GDvuN","option-wrapper":"setting-wrapper__option-wrapper__1I3Ye","option-item":"setting-wrapper__option-item__33la6","label-wrapper":"setting-wrapper__label-wrapper__GiscT","label-text":"setting-wrapper__label-text__CkDVG","label-explain":"setting-wrapper__label-explain__20K6c","label-value":"setting-wrapper__label-value__2E06I"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/time-poll/TimePollContainer/SignUp/CreateSignUp/SettingWrapper/setting-wrapper.scss
// module id = 1794
// module chunks = 1